import { UIText1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './GalleryMoreMenu.css';

interface IGalleryMoreMenuItemProps {
  label: string;
  dataTestId?: string;
  onClick(): void;
}

export const GalleryMoreMenuItem = ({ label, dataTestId, onClick }: IGalleryMoreMenuItemProps) => (
  <button type="button" className={styles['menu-item']} onClick={onClick} data-testid={dataTestId}>
    <UIText1>{label}</UIText1>
  </button>
);
